export default "__VITE_ASSET__178e4383__"